import React from 'react';
import classNames from 'classnames';
import { RCLoadingBars } from '@reverbdotcom/commons/src/rc/RCLoadingBars';

function LoadingOverlay(props) {
  const {
    showOverlay,
    children,
  } = props;

  const classes = classNames('loading-overlay', {
    'loading-overlay--active': showOverlay,
  });

  return (
    <div className={classes}>
      <div className="loading-overlay__content">
        {children}
      </div>
      {showOverlay &&
        <div className="loading-overlay__bars">
          <RCLoadingBars />
        </div>
      }
    </div>
  );
}

export default LoadingOverlay;
